import type { HeroLayoutMode } from "@lib/data/design"

type HeroImageHideOn = "md" | "mobile"

const HERO_FULL_VIEWPORT_SIZES = "100vw"
const HERO_SPLIT_VIEWPORT_SIZES = "(min-width: 768px) 50vw, 100vw"
const HERO_MOBILE_ONLY_SIZES = "(min-width: 768px) 0px, 100vw"
const HERO_DESKTOP_ONLY_FULL_SIZES = "(max-width: 767px) 0px, 100vw"
const HERO_DESKTOP_ONLY_SPLIT_SIZES = "(max-width: 767px) 0px, 50vw"

const isSplitDesktopLayout = (layoutMode: HeroLayoutMode) =>
  layoutMode === "half" || layoutMode === "double"

export const getHeroFillImageSizes = (
  layoutMode: HeroLayoutMode,
  hideOn?: HeroImageHideOn
) => {
  if (hideOn === "md") {
    return HERO_MOBILE_ONLY_SIZES
  }

  if (hideOn === "mobile") {
    return isSplitDesktopLayout(layoutMode)
      ? HERO_DESKTOP_ONLY_SPLIT_SIZES
      : HERO_DESKTOP_ONLY_FULL_SIZES
  }

  return isSplitDesktopLayout(layoutMode)
    ? HERO_SPLIT_VIEWPORT_SIZES
    : HERO_FULL_VIEWPORT_SIZES
}

